// extracted by mini-css-extract-plugin
export default {"hideTooltip":"h--z","fadeIn":"i--z","delay":"j--z","recommendedSizeTooltip":"k--z"};